let Api = {




	"STZX_BIGDATA_DTJC_CQFBGL": "/simple-api/n/qpstzx/dtjc/cqfbgl", //产区分布概览
    "STZX_BIGDATA_DTJC_XDPFSCJGPAGE": "/simple-api/n/qpstzx/dtjc/xdpfscjgPage", //销地批发市场通货价格更多
	"STZX_BIGDATA_DTJC_ZYCPJJ": "/simple-api/n/qpstzx/dtjc/zycpjj", //产地主要品种均价
    

	"STZX_BIGDATA_DTJC_CDHYJGHQ": "/simple-api/n/qpstzx/dtjc/cdhyjghq", //产地货源价格行情
	"STZX_BIGDATA_DTJC_ZYPZFX": "/simple-api/n/qpstzx/dtjc/zypzfx", //主要品种结构分析
	
	
	"STZX_BIGDATA_DTJC_MAPDATA": "/simple-api/n/qpstzx/dtjc/mapData", //地图数据

	"STZX_BIGDATA_DTJC_QRJGQS": "/simple-api/n/qpstzx/dtjc/qrjgqs", //
	
	"STZX_BIGDATA_DTJC_XDPFSCJG": "/simple-api/n/qpstzx/dtjc/xdpfscjg", //销地批发市场通货价格

	"QPSTZX_DTJC_NCPPL": "/simple-api/n/qpstzx/dtjc/ncppl", //

"STZX_BIGDATA_DTJC_CQCNZS": "/simple-api/n/qpstzx/dtjc/cqcnzs", //产区产能走势
	"STZX_BIGDATA_DTJC_PZJGZS": "/simple-api/n/qpstzx/dtjc/pzjgzs", //产地主要品种价格走势






    
}
module.exports = Api